import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const StyledDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

const DataTableToolbar = ({children, ...otherProps}) => <StyledDiv {...otherProps}>{children}</StyledDiv>

DataTableToolbar.propTypes = {
  children: PropTypes.any
}

export {DataTableToolbar}
